import { useMemo } from 'react';
import { Select, SelectProps, SelectOption } from '@ets/design-system';
import { CITATION_PRIORITY } from 'Editor/services/consts';
import { useIntl } from 'react-intl';

type PrioritySelectProps = Pick<
  SelectProps<SelectOption>,
  'disabled' | 'size' | 'width' | 'testId' | 'onChange'
> & {
  value: string;
};

const PrioritySelect = ({
  value,
  onChange,
  disabled,
  size,
  width = '100%',
  testId,
}: PrioritySelectProps) => {
  const intl = useIntl();

  const translationForValue = (value: string) => {
    switch (value) {
      case CITATION_PRIORITY.HIGH:
        return intl.formatMessage({
          id: 'editor.sidebar.review.filter.priority.high',
        });
      case CITATION_PRIORITY.MEDIUM:
        return intl.formatMessage({
          id: 'editor.sidebar.review.filter.priority.medium',
        });
      case CITATION_PRIORITY.LOW:
        return intl.formatMessage({
          id: 'editor.sidebar.review.filter.priority.low',
        });
      default:
        return '';
    }
  };

  const options: SelectOption[] = useMemo(() => {
    return [
      {
        label: translationForValue(CITATION_PRIORITY.HIGH),
        value: CITATION_PRIORITY.HIGH,
        icon: { icon: 'chevron-up', color: 'error', size: '3', testId: 'priority-high-icon' },
      },
      {
        label: translationForValue(CITATION_PRIORITY.MEDIUM),
        value: CITATION_PRIORITY.MEDIUM,
        icon: { icon: 'equals', color: 'warning', size: '3', testId: 'priority-medium-icon' },
      },
      {
        label: translationForValue(CITATION_PRIORITY.LOW),
        value: CITATION_PRIORITY.LOW,
        icon: { icon: 'chevron-down', color: 'success', size: '3', testId: 'priority-low-icon' },
      },
    ];
  }, []);

  return (
    <Select
      variant="standard"
      options={options}
      value={options.filter((option) => option.value === value)}
      onChange={onChange}
      width={width}
      disabled={disabled}
      size={size}
      isClearable={false}
      testId={testId}
    />
  );
};

export default PrioritySelect;
